/**
 * Transfer Request Options
 * Used to track who initiated a transfer (department/project change)
 */
export const TransferRequestOptions = [
  { value: 'Agent request', label: 'Agent request' },
  { value: 'Management request', label: 'Management request' },
  { value: 'Board request', label: 'Board request' },
];

export const TransferRequestValues = [
  'Agent request',
  'Management request',
  'Board request',
];

